import { PlusCircleOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Button, Card, Col, Row, Statistic } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import CSPage from '../../components/CSPage';
import CSPageHeader from '../../components/CSPageHeader';
import useProfile from '../../shared/use-profile';
import { generateUuid } from '../../shared/utils';
import { userSecurityStatsForAdminQuery } from '../security/constants';
import AllUsersTable from './AllUsersTable';

function UserSecurityStatsRow() {
  const { data, error } = useQuery(userSecurityStatsForAdminQuery, {
    fetchPolicy: 'cache-and-network',
  });
  const stats = data?.userSecurityStatsForAdmin;
  if (error || !stats) {
    return null;
  }
  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 24 }}>
      <Col xs={12} sm={12} md={8} lg={6}>
        <Card size="small">
          <Statistic title="Total Users" value={stats.totalUsers} />
        </Card>
      </Col>
      <Col xs={12} sm={12} md={8} lg={6}>
        <Card size="small" style={{ borderTop: '3px solid #52c41a' }}>
          <Statistic title="MFA On" value={stats.mfaOn} />
        </Card>
      </Col>
      <Col xs={12} sm={12} md={8} lg={6}>
        <Card size="small" style={{ borderTop: '3px solid #d9d9d9' }}>
          <Statistic title="MFA Off" value={stats.mfaOff} />
        </Card>
      </Col>
      <Col xs={12} sm={12} md={8} lg={6}>
        <Card size="small" style={{ borderTop: '3px solid #fa8c16' }}>
          <Statistic title="Reset Required" value={stats.resetRequired} />
        </Card>
      </Col>
    </Row>
  );
}

function AllUsersPage() {
  const profile = useProfile();
  const permissions = profile?.permissions;
  const canCreateUser = useMemo(
    () => permissions?.find((p) => p.prefix === 'create-admin-user'),
    [permissions],
  );

  return (
    <>
      <CSPage containerStyle={{ maxWidth: 'unset' }} title="Users">
        <CSPageHeader
          title="Users"
          topActions={[
            canCreateUser && (
              <Link
                key="add"
                to={{
                  pathname: `/user/edit/${generateUuid()}`,
                  state: {
                    mode: 'create',
                  },
                }}
              >
                <Button type="link" icon={<PlusCircleOutlined />} size="large">
                  New User
                </Button>
              </Link>
            ),
          ].filter(Boolean)}
        />
        <UserSecurityStatsRow />
        <AllUsersTable />
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default AllUsersPage;
